"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_run_waitForPlayerSettle = void 0;
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var minigolfGameState_1 = require("./minigolfGameState");
var minigolfGameState_sidecar_1 = require("./minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("./minigolfMainGameGenerator-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
function gen_run_waitForPlayerSettle() {
    var maxTime, cameraTarget, pos, vel, velScale, posAdj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minigolfGameState_sidecar_1.minigolfGameState.get().state = minigolfGameState_1.MinigolfGameStates.waitForPlayerSettle;
                minigolfGameState_sidecar_1.minigolfGameState.resetStillness();
                physicsTickManager_sidecar_1.physicsTickManager.setIsRunning(true);
                return [4 /*yield*/, 0];
            case 1:
                _a.sent();
                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.gameStateString += '!';
                maxTime = minigolfDefs_sidecar_1.minigolfDefs.maxSettleTime;
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 4];
                if (minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.isExitToLevelGenSignaled()) {
                    return [2 /*return*/, 0];
                }
                if (minigolfGameState_sidecar_1.minigolfGameState.get().isAllStill) {
                    return [2 /*return*/, 0];
                }
                if (minigolfDefs_sidecar_1.minigolfDefs.debug_dontWaitForStillness) {
                    return [2 /*return*/, 0];
                }
                maxTime -= common_sidecar_1.common.getUpdateDelta();
                if (maxTime <= 0) {
                    return [2 /*return*/, 0];
                }
                if (!minigolfDefs_sidecar_1.minigolfDefs.debug_dontAutoCamera) {
                    cameraTarget = minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer();
                    if (cameraTarget && !cameraTarget.isDead) {
                        pos = cameraTarget.rigidBody.translation();
                        vel = cameraTarget.rigidBody.linvel();
                        velScale = 0.25;
                        posAdj = minigolfCamera_sidecar_1.minigolfCamera.physicsToCamera(pos.x + vel.x * velScale, pos.y + vel.y * velScale);
                        voyageCamera_sidecar_1.voyageCamera.easeToCenterOn(posAdj.x, posAdj.y, 1 / 60);
                    }
                }
                return [4 /*yield*/, 0];
            case 3:
                _a.sent();
                return [3 /*break*/, 2];
            case 4: return [2 /*return*/, 0];
        }
    });
}
exports.gen_run_waitForPlayerSettle = gen_run_waitForPlayerSettle;
